module.exports = __webpack_public_path__ + "img/video.2f889a1f.png";